<template>
  <span>
    <span :class="['label', `label-production-panel-status-${status}`]">{{status | formatLookupName(ProductionPanelStatusTypeLookup)}}</span>
    <span :class="['label', `label-order-tasks-assigned`, `ml-1`]" v-if="isActiveTransferTasksAssigned"><i class="far fa-fw fa-calendar-check"></i> Tasks Assigned</span>
  </span>
</template>

<script>
import { ProductionPanelStatusTypeLookup } from '@/store/types'

export default {
  name: 'LabelPanelStatusBadge',
  props: {
    status: String,
    isActiveTransferTasksAssigned: Boolean,
  },
  created() {
    this.ProductionPanelStatusTypeLookup = ProductionPanelStatusTypeLookup
  },
}
</script>
